import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { AudioPlayer, Box, Skeleton, Text } from '@hivewatch/dark'

import { getRoleDisplayName } from '@/features/managed-accounts'
import { NotificationSubtitle } from '@/features/notification'
import { Notification } from '@/graphql/appsync-notifications'
import { useNotificationAudioMessagesQuery } from '@/graphql/generated/hooks'

import { getNotificationsTabTokens } from '../../styles/tokens'

export const AudioNotification = ({
  notification,
  onClick,
}: {
  notification: Notification
  onClick: () => void
}) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const tokens = getNotificationsTabTokens(colorScheme)
  const { data, loading: isLoading } = useNotificationAudioMessagesQuery({
    variables: {
      id: notification.audioMessageId,
    },
  })
  const url = data?.audioMessages.edges[0]?.node.audioClip.url

  const roleDisplayName = getRoleDisplayName(notification.audioMessageUserRole)
  const senderDisplayName = `${roleDisplayName} ${notification.audioMessageUserName}`

  return (
    <Box color={tokens.textPrimary} flex={1}>
      <Box cursor='pointer' onClick={onClick}>
        <Text
          data-testid='AudioNotification:header'
          lineClamp={2}
          mb={1.5}
          textStyle='label'
        >
          {senderDisplayName} {t('common:notification_sent_voice_message')}{' '}
          <Box as='span' color={tokens.incidentLink} textStyle='label'>
            {notification.incidentDisplayId} {notification.incidentName}
          </Box>
        </Text>
        <NotificationSubtitle
          facilityShortName={notification?.facilityShortName}
          fontSize='11px'
          sourceName={notification?.incidentSourceName}
          timestamp={notification?.notificationTimestamp}
        />
      </Box>
      {isLoading ? (
        <Skeleton height='34px' width='91%' />
      ) : (
        url && <AudioPlayer colorScheme={colorScheme} url={url} />
      )}
    </Box>
  )
}
